export const isNodeVisible = (node: BaseNode) => {
  if ('visible' in node && !node.visible) return false;
  if ('opacity' in node && node.opacity <= 0.05) return false;

  return true;
};
